import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/auth";
import BodyMap from "@/components/quantum/BodyMap";
import { TensionShift } from "@/components/quantum/GuidedPractice";
import { getFigures } from "@/lib/bodyRegions";
import PracticeReflection from "@/components/app/PracticeReflection";

const KEY = "tt-body-before";

// Before/after body check for a solo practice: mark current and tension, then see what eased. Saved to Body insights.
export default function BodyCheckCard({ app, practice, stage, testId = "body-check" }) {
  const [open, setOpen] = useState(stage === "after" && Boolean(sessionStorage.getItem(KEY)));
  const [current, setCurrent] = useState({});
  const [tension, setTension] = useState({});
  const [saved, setSaved] = useState(false);
  const [checkId, setCheckId] = useState(null);
  const figure = getFigures().solo;
  const [before] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem(KEY) || "null");
    } catch {
      return null;
    }
  });
  const keep = () => {
    sessionStorage.setItem(KEY, JSON.stringify({ current, tension, practice }));
    setSaved(true);
    toast.success("Held. We’ll check in again after the practice.");
  };
  const save = () => api.post("/body/checks", { app, practice, before: before ? { current: before.current, tension: before.tension } : { current: {}, tension: {} }, after: { current, tension } })
    .then(({ data }) => { sessionStorage.removeItem(KEY); setSaved(true); setCheckId(data?.id ?? null); })
    .catch(() => toast.error("Your body check couldn’t be saved just now."));
  if (!open) return <button data-testid={`${testId}-open`} onClick={() => setOpen(true)} className="mt-6 w-full rounded-full border border-[#9DB4D6]/50 py-3 text-[13px] text-[#9DB4D6] hover:bg-[#9DB4D6] hover:text-[#0A0706] transition-colors">{stage === "before" ? "Check in with your body first" : "Check in with your body again"}</button>;
  return (
    <section data-testid={testId} className="mt-6 border border-[#9DB4D6]/30 p-5 text-left">
      <p className="font-display text-2xl">{stage === "before" ? "Before you begin" : "And now?"}</p>
      <p className="mt-1 text-[13px] text-[#A8998C]">Mark where you feel current, then switch to Tension and mark where you hold tension.</p>
      <div className="mt-4"><BodyMap figure={figure} value={current} onChange={saved ? undefined : setCurrent} tension={tension} onTension={saved ? undefined : setTension} testId={`${testId}-map`} /></div>
      {saved ? (stage === "after" ? <><TensionShift before={before?.tension ?? {}} after={tension} /><PracticeReflection checkId={checkId} testId={`${testId}-reflection`} /></> : <p data-testid={`${testId}-held`} className="mt-4 text-[14px] text-[#9DB4D6]">Held for after your practice.</p>) : (
        <button data-testid={`${testId}-save`} onClick={stage === "before" ? keep : save} className="mt-5 w-full rounded-full bg-[#9DB4D6] text-[#0A0706] py-3 font-tt-mono text-[11px] uppercase tracking-[0.2em] hover:bg-[#F2E8DF] transition-colors">{stage === "before" ? "Hold this and begin" : "Save and see what eased"}</button>
      )}
    </section>
  );
}
